module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.nodePathAndName) + ":  Raw Data")]), _vm._v(" "), _c('h3', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Save node"
    },
    on: {
      "click": _vm.saveButtonClick
    }
  }, [_vm._v("\n                Save\n                "), _c('span', {
    staticClass: "fa fa-save"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rawValue),
      expression: "rawValue"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "20",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.rawValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rawValue = $event.target.value
      }
    }
  })])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4dd86192", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dd86192"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/raw-node-editor/raw-node-editor.vue.html
// module id = 1104
// module chunks = 0